export const CHANNEL_SEGMENT = {
  ADULT: 'ADULT',
  PEDIATRIC: 'PEDIATRIC'
}

export const CHANNEL_SEGMENT_LABEL = {
  [CHANNEL_SEGMENT.ADULT]: 'Adulto',
  [CHANNEL_SEGMENT.PEDIATRIC]: 'Infantil'
}

export const VIRTUAL_CLINIC_SCREEN_STATUS = {
  READY: 'READY',
  OFFLINE: 'OFFLINE',
  ONGOING: 'ONGOING',
  EMPTY: 'EMPTY'
}

export const ORDER_QUEUE_BY = {
  FIRST: 'FIRST',
  PEDIATRIC: 'PEDIATRIC'
}
